import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Users, UserPlus, AlertTriangle, Wallet, Eye, Ban, RefreshCw, ShieldAlert, X, MapPin, Calendar, CreditCard, TrendingUp, Package } from 'lucide-react';
import { StatsCard } from '../components/StatsCard';
import { DataTable } from '../components/DataTable';
import { StatusBadge } from '../components/StatusBadge';
const customers = [{
  id: 1,
  name: 'Alice Smith',
  email: 'alice@example.com',
  phone: '+1 234 567 8910',
  status: 'active',
  rides: 45,
  balance: '₦124.50',
  lastActive: '2 hours ago',
  risk: 'low',
  joined: 'Jan 15, 2024',
  totalSpent: '₦2,340.00',
  avgRating: 4.8,
  lastLocation: 'Downtown, Lagos',
  paymentMethod: 'Wallet'
}, {
  id: 2,
  name: 'Bob Johnson',
  email: 'bob@example.com',
  phone: '+1 234 567 8911',
  status: 'active',
  rides: 12,
  balance: '₦34.00',
  lastActive: '1 day ago',
  risk: 'low',
  joined: 'Feb 20, 2024',
  totalSpent: '₦560.00',
  avgRating: 4.5,
  lastLocation: 'Victoria Island',
  paymentMethod: 'Card'
}, {
  id: 3,
  name: 'Charlie Brown',
  email: 'charlie@example.com',
  phone: '+1 234 567 8912',
  status: 'suspended',
  rides: 2,
  balance: '-₦15.00',
  lastActive: '2 months ago',
  risk: 'high',
  joined: 'Mar 5, 2024',
  totalSpent: '₦85.00',
  avgRating: 2.1,
  lastLocation: 'Ikeja',
  paymentMethod: 'Wallet'
}, {
  id: 4,
  name: 'David Wilson',
  email: 'david@example.com',
  phone: '+1 234 567 8913',
  status: 'blocked',
  rides: 8,
  balance: '₦0.00',
  lastActive: '5 days ago',
  risk: 'high',
  joined: 'Jan 28, 2024',
  totalSpent: '₦420.00',
  avgRating: 3.2,
  lastLocation: 'Lekki',
  paymentMethod: 'Card'
}, {
  id: 5,
  name: 'Eve Davis',
  email: 'eve@example.com',
  phone: '+1 234 567 8914',
  status: 'active',
  rides: 156,
  balance: '₦45.20',
  lastActive: '10 min ago',
  risk: 'low',
  joined: 'Dec 10, 2023',
  totalSpent: '₦8,920.00',
  avgRating: 4.9,
  lastLocation: 'Ikoyi',
  paymentMethod: 'Wallet'
}, {
  id: 6,
  name: 'Frank Miller',
  email: 'frank@example.com',
  phone: '+1 234 567 8915',
  status: 'active',
  rides: 34,
  balance: '₦89.00',
  lastActive: '3 days ago',
  risk: 'medium',
  joined: 'Feb 1, 2024',
  totalSpent: '₦1,560.00',
  avgRating: 4.3,
  lastLocation: 'Surulere',
  paymentMethod: 'Card'
}, {
  id: 7,
  name: 'Grace Lee',
  email: 'grace@example.com',
  phone: '+1 234 567 8916',
  status: 'active',
  rides: 89,
  balance: '₦230.00',
  lastActive: '1 week ago',
  risk: 'low',
  joined: 'Jan 5, 2024',
  totalSpent: '₦4,120.00',
  avgRating: 4.7,
  lastLocation: 'Yaba',
  paymentMethod: 'Wallet'
}, {
  id: 8,
  name: 'Henry Ford',
  email: 'henry@example.com',
  phone: '+1 234 567 8917',
  status: 'inactive',
  rides: 0,
  balance: '₦0.00',
  lastActive: 'Never',
  risk: 'low',
  joined: 'Mar 15, 2024',
  totalSpent: '₦0.00',
  avgRating: 0,
  lastLocation: 'N/A',
  paymentMethod: 'None'
}];
export function CustomerManagement() {
  const [activeTab, setActiveTab] = useState('all');
  const [selectedCustomer, setSelectedCustomer] = useState<any>(null);
  const columns = [{
    header: 'Customer',
    accessor: (row: any) => <div className="flex items-center gap-3" data-id="element-147">
          <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-sm font-bold text-blue-600 relative" data-id="element-148">
            {row.name.charAt(0)}
            {row.risk === 'high' && <span className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full border-2 border-white" data-id="element-149" />}
          </div>
          <div data-id="element-150">
            <p className="font-medium text-slate-900" data-id="element-151">{row.name}</p>
            <p className="text-xs text-slate-500" data-id="element-152">{row.email}</p>
          </div>
        </div>
  }, {
    header: 'Phone',
    accessor: 'phone'
  }, {
    header: 'Status',
    accessor: (row: any) => <StatusBadge status={row.status} data-id="element-153" />
  }, {
    header: 'Total Rides',
    accessor: 'rides'
  }, {
    header: 'Wallet Balance',
    accessor: (row: any) => <span className={`font-medium ${row.balance.startsWith('-') ? 'text-red-600' : 'text-slate-700'}`} data-id="element-154">
          {row.balance}
        </span>
  }, {
    header: 'Last Active',
    accessor: 'lastActive'
  }];
  const filteredData = activeTab === 'all' ? customers : activeTab === 'risk' ? customers.filter(c => c.risk === 'high' || c.risk === 'medium') : customers.filter(c => c.status === activeTab);
  return <div className="space-y-6" data-id="element-155">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6" data-id="element-156">
        <StatsCard title="Total Customers" value="28,493" trend={8} icon={Users} color="blue" delay={0} data-id="element-157" />
        <StatsCard title="New Signups" value="145" trend={12} icon={UserPlus} color="green" delay={0.1} data-id="element-158" />
        <StatsCard title="Flagged Accounts" value="24" trend={5} icon={AlertTriangle} color="gold" delay={0.2} data-id="element-159" />
        <StatsCard title="Total Wallet Balance" value="₦452,100" trend={3} icon={Wallet} color="purple" delay={0.3} data-id="element-160" />
      </div>

      <div className="flex border-b border-slate-200" data-id="element-161">
        <button onClick={() => setActiveTab('all')} className={`px-6 py-3 text-sm font-medium border-b-2 transition-colors ${activeTab === 'all' ? 'border-famo-gold text-famo-navy' : 'border-transparent text-slate-500 hover:text-slate-700'}`} data-id="element-162">
          All Customers
        </button>
        <button onClick={() => setActiveTab('active')} className={`px-6 py-3 text-sm font-medium border-b-2 transition-colors ${activeTab === 'active' ? 'border-famo-gold text-famo-navy' : 'border-transparent text-slate-500 hover:text-slate-700'}`} data-id="element-163">
          Active
        </button>
        <button onClick={() => setActiveTab('risk')} className={`px-6 py-3 text-sm font-medium border-b-2 transition-colors flex items-center gap-2 ${activeTab === 'risk' ? 'border-famo-gold text-famo-navy' : 'border-transparent text-slate-500 hover:text-slate-700'}`} data-id="element-164">
          <ShieldAlert size={16} data-id="element-165" />
          High Risk
        </button>
      </div>

      <motion.div key={activeTab} initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3
    }} data-id="element-166">
        <DataTable data={filteredData} columns={columns} searchPlaceholder="Search customers by name, email, phone..." actions={row => <>
              <button onClick={() => setSelectedCustomer(row)} className="p-1.5 text-slate-500 hover:text-famo-navy hover:bg-slate-100 rounded transition-colors" title="View Profile" data-id="element-168">
                <Eye size={18} data-id="element-169" />
              </button>
              <button className="p-1.5 text-blue-500 hover:bg-blue-50 rounded transition-colors" title="Refund/Adjust Wallet" data-id="element-170">
                <RefreshCw size={18} data-id="element-171" />
              </button>
              <button className="p-1.5 text-red-500 hover:bg-red-50 rounded transition-colors" title="Block Account" data-id="element-172">
                <Ban size={18} data-id="element-173" />
              </button>
            </>} data-id="element-167" />
      </motion.div>

      {/* Customer Detail Panel */}
      <AnimatePresence data-id="element-174">
        {selectedCustomer && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={() => setSelectedCustomer(null)} data-id="element-175">
            <motion.div initial={{
          scale: 0.95,
          y: 20
        }} animate={{
          scale: 1,
          y: 0
        }} exit={{
          scale: 0.95,
          y: 20
        }} onClick={e => e.stopPropagation()} className="bg-white rounded-xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto" data-id="element-176">
              {/* Header */}
              <div className="p-6 border-b border-slate-200 flex justify-between items-start bg-slate-50" data-id="element-177">
                <div className="flex items-center gap-4" data-id="element-178">
                  <div className="w-16 h-16 rounded-full bg-blue-100 flex items-center justify-center text-2xl font-bold text-blue-600" data-id="element-179">
                    {selectedCustomer.name.charAt(0)}
                  </div>
                  <div data-id="element-180">
                    <h2 className="text-xl font-bold text-slate-900" data-id="element-181">
                      {selectedCustomer.name}
                    </h2>
                    <p className="text-sm text-slate-500" data-id="element-182">
                      {selectedCustomer.email}
                    </p>
                    <div className="mt-1" data-id="element-183">
                      <StatusBadge status={selectedCustomer.status} data-id="element-184" />
                    </div>
                  </div>
                </div>
                <button onClick={() => setSelectedCustomer(null)} className="p-2 hover:bg-slate-200 rounded-lg transition-colors" data-id="element-185">
                  <X size={20} className="text-slate-500" data-id="element-186" />
                </button>
              </div>

              {/* Content */}
              <div className="p-6 space-y-6" data-id="element-187">
                {/* Stats Grid */}
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-188">
                  <div className="bg-blue-50 p-4 rounded-lg" data-id="element-189">
                    <Package size={20} className="text-blue-600 mb-2" data-id="element-190" />
                    <p className="text-2xl font-bold text-slate-900" data-id="element-191">
                      {selectedCustomer.rides}
                    </p>
                    <p className="text-xs text-slate-600" data-id="element-192">Total Rides</p>
                  </div>
                  <div className="bg-green-50 p-4 rounded-lg" data-id="element-193">
                    <TrendingUp size={20} className="text-green-600 mb-2" data-id="element-194" />
                    <p className="text-2xl font-bold text-slate-900" data-id="element-195">
                      {selectedCustomer.totalSpent}
                    </p>
                    <p className="text-xs text-slate-600" data-id="element-196">Total Spent</p>
                  </div>
                  <div className="bg-purple-50 p-4 rounded-lg" data-id="element-197">
                    <Wallet size={20} className="text-purple-600 mb-2" data-id="element-198" />
                    <p className="text-2xl font-bold text-slate-900" data-id="element-199">
                      {selectedCustomer.balance}
                    </p>
                    <p className="text-xs text-slate-600" data-id="element-200">Wallet Balance</p>
                  </div>
                  <div className="bg-yellow-50 p-4 rounded-lg" data-id="element-201">
                    <span className="text-2xl mb-2 block" data-id="element-202">⭐</span>
                    <p className="text-2xl font-bold text-slate-900" data-id="element-203">
                      {selectedCustomer.avgRating || 'N/A'}
                    </p>
                    <p className="text-xs text-slate-600" data-id="element-204">Avg Rating</p>
                  </div>
                </div>

                {/* Details */}
                <div className="space-y-4" data-id="element-205">
                  <h3 className="font-bold text-slate-800" data-id="element-206">Account Details</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-207">
                    <div className="flex items-center gap-3 p-3 bg-slate-50 rounded-lg" data-id="element-208">
                      <Calendar size={18} className="text-slate-400" data-id="element-209" />
                      <div data-id="element-210">
                        <p className="text-xs text-slate-500" data-id="element-211">Joined</p>
                        <p className="font-medium text-slate-900" data-id="element-212">
                          {selectedCustomer.joined}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center gap-3 p-3 bg-slate-50 rounded-lg" data-id="element-213">
                      <CreditCard size={18} className="text-slate-400" data-id="element-214" />
                      <div data-id="element-215">
                        <p className="text-xs text-slate-500" data-id="element-216">Payment Method</p>
                        <p className="font-medium text-slate-900" data-id="element-217">
                          {selectedCustomer.paymentMethod}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center gap-3 p-3 bg-slate-50 rounded-lg" data-id="element-218">
                      <MapPin size={18} className="text-slate-400" data-id="element-219" />
                      <div data-id="element-220">
                        <p className="text-xs text-slate-500" data-id="element-221">Last Location</p>
                        <p className="font-medium text-slate-900" data-id="element-222">
                          {selectedCustomer.lastLocation}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center gap-3 p-3 bg-slate-50 rounded-lg" data-id="element-223">
                      <AlertTriangle size={18} className={selectedCustomer.risk === 'high' ? 'text-red-500' : selectedCustomer.risk === 'medium' ? 'text-yellow-500' : 'text-green-500'} data-id="element-224" />
                      <div data-id="element-225">
                        <p className="text-xs text-slate-500" data-id="element-226">Risk Level</p>
                        <p className="font-medium text-slate-900 capitalize" data-id="element-227">
                          {selectedCustomer.risk}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Actions */}
                <div className="flex gap-3 pt-4 border-t border-slate-200" data-id="element-228">
                  <button className="flex-1 bg-blue-50 text-blue-700 hover:bg-blue-100 py-2 rounded-lg font-medium transition-colors" data-id="element-229">
                    Adjust Wallet
                  </button>
                  <button className="flex-1 bg-green-50 text-green-700 hover:bg-green-100 py-2 rounded-lg font-medium transition-colors" data-id="element-230">
                    View Ride History
                  </button>
                  <button className="flex-1 bg-red-50 text-red-700 hover:bg-red-100 py-2 rounded-lg font-medium transition-colors" data-id="element-231">
                    {selectedCustomer.status === 'blocked' ? 'Unblock' : 'Block Account'}
                  </button>
                </div>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}